import { Link, useParams } from "react-router-dom";
import { useProfile } from "@/features/profile/hooks/profileQueries";
import { Brand } from "@/shared/components/ui/Brand";
import { cn } from "@/shared/utils/cn";
import { navigationState } from "@/core/routing/navigationPolicy";

export function DashboardHeader({ view = "today" }: { view?: "today" | "agenda" }) {
  const { businessId, locationId } = useParams();
  const { data: profile } = useProfile();
  const basePath = `/b/${businessId}/l/${locationId}`;

  return (
    <header className="mx-auto flex w-full max-w-[960px] shrink-0 items-center gap-3 px-4 py-4 sm:gap-6 sm:px-[30px] sm:py-5">
      <Link to={basePath} state={navigationState("start")} aria-label={profile?.firstName ? `Froppio home, ${profile.firstName}` : "Froppio home"} className="rounded-xl focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring">
        <Brand wordmark className="max-[360px]:[&>span:last-child]:text-lg" />
      </Link>
      <nav aria-label="Dashboard views" className="flex min-w-0 flex-1 gap-1 rounded-2xl bg-muted p-1">
        {[
          { id: "today", label: "Today", to: basePath },
          { id: "agenda", label: "Agenda", to: `${basePath}/agenda` },
        ].map((tab) => (
          <Link
            key={tab.id}
            to={tab.to}
            aria-current={view === tab.id ? "page" : undefined}
            className={cn(
              "flex min-h-11 min-w-0 flex-1 items-center justify-center whitespace-nowrap rounded-xl px-1 text-sm font-bold focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
              view === tab.id ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:bg-card/60",
            )}
          >
            {tab.label}
          </Link>
        ))}
      </nav>
    </header>
  );
}
